import React, { useState } from 'react';

import classNames from 'classnames';

const Tooltip = ({ content, position, children }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className='tooltip_wrapper' onMouseEnter={() => setVisible(true)} onMouseLeave={() => setVisible(false)}>
      {children}
      {visible && <div className={classNames('tooltip', position)}>{content}</div>}
    </div>
  );
};

export default Tooltip;
